import { render, staticRenderFns } from "./LandlordProfile.vue?vue&type=template&id=3cc8beac&scoped=true"
import script from "./LandlordProfile.vue?vue&type=script&lang=js"
export * from "./LandlordProfile.vue?vue&type=script&lang=js"
import style0 from "./LandlordProfile.vue?vue&type=style&index=0&id=3cc8beac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8beac",
  null
  
)

export default component.exports